import React from 'react';
import load from '../load.gif';
import {Grid} from "@material-ui/core";

const Select = ({datas, handleChange, id, engine, lang, wait}) => {

    const Option = () => {

        try {
            const replaceBulk = (str, findArray, replaceArray) => {
                let i, regex = [], map = {};
                for (i = 0; i < findArray.length; i++) {
                    regex.push(findArray[i].replace(/([-[\]{}()*+?.\\^$|#,])/g, '\\$1'));
                    map[findArray[i]] = replaceArray[i];
                }
                regex = regex.join('|');
                str = str.replace(new RegExp(regex, 'g'), function (matched) {
                    return map[matched];
                });
                return str;
            }
            if (engine === 1) {
                return datas.map((data) => (
                    <option key={data.id} value={data.id}>{data.my_data != null ? data.my_data.name + ' ' + data.my_data.hp : data.var_title + ' ' + data.int_hp}Hp</option>
                ));
            } else {
                return datas.map((data) => (
                    <option key={data.id} value={data.id}>{data.my_data != null ? data.my_data.name : data.var_title}</option>
                ));
            }
        } catch (e) {
            return <></>
        }
    }
    const LoadDiv = () => {
        return <Grid container justify={"center"} alignItems={"center"} alignContent={"center"}><img style={{border: "none"}} src={load}/> </Grid>

    }

    if (wait) {
        return (<LoadDiv/>)
    } else {
        return (<select className={'acr-select'} onChange={handleChange} value={id}>
            <option value={''}>{lang.select}</option>
            <Option/>
        </select>)
    }
}

export default Select;